function isNewRequestSignalEnabled() {
  return document.getElementById('new-request-signal-switch')?.checked === true
}

function setupNewRequestPeriodicalChecker() {
  window.latestLocalServiceRequestTimestamp = Number(document.body.dataset.latestServiceRequestTimestamp)
  window.latestLocalMessageTimestamp = Number(document.body.dataset.latestMessageTimestamp)
  
  if (window.newRequestPeriodicalChecker !== undefined) return;

  window.newRequestPeriodicalChecker = setInterval(() => {
    console.debug("fetch latest_service_request_timestamp")

    fetch('/agent/service_requests/latest_service_request_timestamp')
      .then(response => response.json())
      .then(data => {
        const latestRemoteServiceRequestTimestamp = data.latest_service_request_timestamp
        const latestRemoteMessageTimestamp = data.latest_message_timestamp
        const timePassedSinceLatest = latestRemoteServiceRequestTimestamp - latestLocalServiceRequestTimestamp
        const timePassedSinceLatestMessage = latestRemoteMessageTimestamp - latestLocalMessageTimestamp

        // console.debug("LOCAL latestLocalServiceRequestTimestamp", window.latestLocalServiceRequestTimestamp,
        //   "latestLocalMessageTimestamp", window.latestLocalMessageTimestamp)
        // console.debug("SERVER latestRemoteServiceRequestTimestamp", latestRemoteServiceRequestTimestamp,
        //   "latestRemoteMessageTimestamp", latestRemoteMessageTimestamp)

        if (timePassedSinceLatest > 0 || timePassedSinceLatestMessage > 0) {
          window.latestLocalServiceRequestTimestamp = latestRemoteServiceRequestTimestamp
          window.latestLocalMessageTimestamp = latestRemoteMessageTimestamp

          const noCallIsInProgress = document.querySelector("[id*='call_service_request']") === null &&
                                      document.querySelector("[data-controller='call']") === null
          const agentIsAtTheMainPage = document.querySelector("[data-controller='online-agents']") !== null

          console.debug("NEW REQUEST noCallIsInProgress ", noCallIsInProgress,
            " agentIsAtTheMainPage ", agentIsAtTheMainPage)

          if (noCallIsInProgress && agentIsAtTheMainPage) {
            if (isNewRequestSignalEnabled()) {
              if (timePassedSinceLatest > 0) {
                console.debug("PLAY NEW REQUEST SIGNAL")
                new Audio(document.body.dataset.newRequestSignalUrl).play()
              } else if (timePassedSinceLatestMessage > 0) {
                console.debug("PLAY NEW MESSAGE SIGNAL")
                new Audio(document.body.dataset.newMessageSignalUrl).play()
              }
            }

            console.debug("REFRESH PAGE due to new data")
            Turbo.visit(window.location.href, { action: 'replace' })
          }
        }
      })
      .catch(error => console.error('Error: ', error))
  }, 5000)
}

function requestNotificationPermission() {
  console.debug('requestNotificationPermission')

  if ("Notification" in window) {
    console.debug("Notification permission: ", Notification.permission)

    if (Notification.permission !== "denied" && Notification.permission !== "granted") {
      Notification.requestPermission()
    }
  }
}

function showPermissionPopup()  {
  document.getElementById('sound-permission-popup').classList.remove('hidden')
}

function setupNewRequestPeriodicalCheckerIfEnabled() {
  if (!document.getElementById('new-request-signal-switch')) return;

  setupNewRequestPeriodicalChecker()

  if (isNewRequestSignalEnabled()) {
    requestNotificationPermission()
  }
}

async function checkAutoplay() {
  const audio = new Audio(document.body.dataset.silenceUrl);
  try {
    await audio.play();
    console.debug('Autoplay is allowed');
    window.autoplayAllowed = true
  } catch (err) {
    window.autoplayAllowed = false
    console.debug('Autoplay is not allowed', err);
  }
}

window.addEventListener('DOMContentLoaded', (e) => {
  checkAutoplay()
  console.debug("DOMContentLoaded new_request_signal")
  
  const newRequestSignalSwitch = document.getElementById('new-request-signal-switch')
  setupNewRequestPeriodicalCheckerIfEnabled()

  newRequestSignalSwitch?.addEventListener('change', (e) => {
    sessionStorage.setItem('newRequestSignalEnabled', newRequestSignalSwitch.checked)

    if (isNewRequestSignalEnabled()) {
      if (checkAutoplay() && !window.autoplayAllowed) showPermissionPopup()
    }

    setupNewRequestPeriodicalCheckerIfEnabled()
  })
})
